import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=fa594314&"
import script from "./LeadList.vue?vue&type=script&lang=js&"
export * from "./LeadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports